<template>
  <div class="search-ads-campaigns-stats-install-box">
    <header class="search-ads-campaigns-stats-install-box__header">
      <img
        :src="require('@/assets/images/target.svg')"
        class="search-ads-campaigns-stats-install-box__header-image"
      />
    </header>
    <div class="row">
      <div class="columns large-6">
        <div class="search-ads-campaigns-stats-install-box__stats-title">
          {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_INSTALL_STATS') }}
        </div>
        <div class="search-ads-campaigns-stats-install-box__stats-value">
          {{ totalInstallFormatted }} {{ $t('INSTALL') }}
        </div>
      </div>
      <div class="columns large-6">
        <div class="search-ads-campaigns-stats-install-box__stats-title">
          {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_AVERAGE_INSTALL_STATS') }}
        </div>
        <div class="search-ads-campaigns-stats-install-box__stats-value">
          {{ averageInstallFormattedAndFixed }} {{ $t('INSTALL') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/number';

export default {
  name: 'SearchAdsCampaignsStatsInstallBox',
  props: {
    totalInstall: {
      type: Number,
      required: true,
    },
    averageInstall: {
      type: Number,
      required: true,
    },
  },
  computed: {
    totalInstallFormatted() {
      return format(this.totalInstall);
    },
    averageInstallFormattedAndFixed() {
      return format(this.averageInstall.toFixed(2));
    },
  },
};
</script>

<style lang="scss">
.search-ads-campaigns-stats-install-box {
  width: 100%;
  background-color: #fff;

  border: 1px solid $lb-light-gray;
  border-radius: $lb-border-radius * 5;
  padding: $global-padding * 2;

  background-repeat: no-repeat;
  background-position: -12% top;

  @include rtl() {
    background-position: right top;
  }

  &__header {
    margin-bottom: $global-margin * 1.5;
  }

  &__stats {
    &-value {
      font-weight: bold;
      font-size: rem-calc(20px);
      margin-top: $global-margin * 0.25;
    }
  }
}
</style>
